import { ExModule } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state: State = {
  alertView: {
    isVisible: false,
    title: undefined,
    message: undefined
  },
  apiError: {
    code: undefined,
    message: ""
  },
  grpcError: {
    code: undefined,
    message: ""
  }
};

const commonModule: ExModule<State, Actions, Getters, Mutations> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default commonModule;
